exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".toolbar{background:#fbfbfc;border:1px solid #e2dee6;border-bottom:none;border-radius:3px 3px 0 0;box-shadow:0 1px 0 #e2dee6;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/toolbar.less
// module id = 1130
// module chunks = 74